<template>
  <el-form
    :model="form"
    ref="form">
    <!-- SUPPLIER -->
    <div class="row">
      <!-- title -->
      <div class="col-12">
        <h3 class="blue-text">{{L10n('supplier')}}</h3>
      </div>
      <!-- content -->
      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('supplier')"
          prop="supplierCompanyID"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <select-company
            :model.sync="form.supplierCompanyID"
            @on-created="mixCreateSupplier"
            @on-change="(id) => mixChangeSupplierID(id, { required: true })"
          ></select-company>
        </el-form-item>
      </div>
      <div class="col-md-6 col-12">
        <el-form-item
          :label="L10n('supplier-detail')"
          prop="supplierCompanyDetailID"
          :rules="getValidationRule('required')"
          class="material-style">
          <select-company-detail
            :model.sync="form.supplierCompanyDetailID"
            :companyID="form.supplierCompanyID"
            @update:model="updateModelItem('supplierCompanyDetailID', { required: true })"
          ></select-company-detail>
        </el-form-item>
      </div>
      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('supplier-contact')"
          prop="supplierCompanyContactID"
          class="material-style">
          <select-company-contact
            :model.sync="form.supplierCompanyContactID"
            :companyID="form.supplierCompanyID"
            @update:model="updateModelItem('supplierCompanyContactID', { required: false })"
          ></select-company-contact>
        </el-form-item>
      </div>
      <div class="col-md-4 col-sm-6 col-12">
        <el-form-item
          :label="L10n('vat')"
          prop="vatID"
          class="material-style"
        >
          <select-response
            :model.sync="form.vatID"
            @update:model="updateModelItem('vatID', { required: false })"
            :fields="{ id: 'id', title: 'country'}"
            :data="dataSourceVAT.records"
            :isLoading="dataSourceVAT.loading"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-md-4 col-sm-6 col-12">
        <el-form-item
          :label="L10n('country')"
          prop="countryOriginID"
          class="material-style"
        >
          <select-response
            :model.sync="form.countryOriginID"
            @update:model="updateModelItem('countryOriginID', { required: false })"
            :data="dataSourceCountry.records"
            :isLoading="dataSourceCountry.loading"
          ></select-response>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'
import { mixUpdateSupplier } from '@/mixins/companies'
import { vatsDataSourceConverter } from '@/utils/shared'

export default {
  name: 'FormPO',
  mixins: [Form, mixUpdateSupplier],
  components: {
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue'),
    'select-company-detail': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyDetail/Index.vue'),
    'select-company-contact': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyContact/Index.vue')
  },
  props: {
    dataID: { required: true }
  },
  data () {
    return {
      configSupplier: Object.freeze({
        companyField: 'supplierCompanyID',
        relatedFields: [
          {
            fieldName: 'supplierCompanyContactID',
            createField: 'contactID'
          },
          {
            fieldName: 'supplierCompanyDetailID',
            createField: 'companyDetailID'
          }
        ]
      })
    }
  },
  computed: {
    dataSourceVAT () {
      return vatsDataSourceConverter(this.API('VATs/GetAllDynamic?select=id,country&OrderBy=country'))
    },
    dataSourceCountry () {
      return this.API('CountryOrigins/GetAllDynamic?select=id,title')
    }
  },
  methods: {
    updateModelItem (fieldName, payload = {}) {
      let payloadMixin = { api: `SalesOrders/Patch/${this.dataID}`, id: this.dataID }
      this.$emit('updateModelItem', fieldName, this.form[fieldName], { ...payloadMixin, ...payload })
    }
  }
}
</script>
